import {
  SET_RADIUS_OPEN,
  SHOW_AUTOCOMPLETE_KEYWORD,
  SHOW_AUTOCOMPLETE_WORKPLACE
} from 'src/redux/constant/actionsType';


const showAutocompleteWorkplace = (state = false) => ({
  type: SHOW_AUTOCOMPLETE_WORKPLACE,
  state
});

const showAutocompleteKeyword = (state = false) => ({
  type: SHOW_AUTOCOMPLETE_KEYWORD,
  state
});

const setRadiusOpen = (action = true) => ({
  type: SET_RADIUS_OPEN,
  state: action
});

export {
  showAutocompleteWorkplace,
  showAutocompleteKeyword,
  setRadiusOpen
};
